import Vue from 'vue'
import Router from 'vue-router'

import Home from '@/components/HomePage.vue'
import Contatti from '@/components/Contatti.vue'
import ChiSiamo from '@/components/ChiSiamo.vue'
import Prodotti from '@/components/Prodotti.vue'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home
    },
    {
      path: '/contatti',
      name: 'Contatti',
      component: Contatti
    },
    {
      path: '/chisiamo',
      name: 'ChiSiamo',
      component: ChiSiamo
    },
    {
      path: '/prodotti',
      name: 'PaginaProdotti',
      component: Prodotti
    }
  ]
})
